import { render, staticRenderFns } from "./PackageBuilder.vue?vue&type=template&id=be79f6f0&scoped=true"
import script from "./PackageBuilder.vue?vue&type=script&lang=js"
export * from "./PackageBuilder.vue?vue&type=script&lang=js"
import style0 from "./PackageBuilder.vue?vue&type=style&index=0&id=be79f6f0&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "be79f6f0",
  null
  
)

export default component.exports